import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgDeleteIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path d="M49.818 22.606a3.6 3.6 0 0 0-1.205-.936 3.5 3.5 0 0 0-1.472-.337H19.526c-.507 0-1.009.114-1.47.333-.46.218-.87.537-1.201.934s-.576.862-.716 1.366a3.8 3.8 0 0 0-.1 1.55l4.755 32.726a3.64 3.64 0 0 0 1.183 2.22c.64.569 1.46.878 2.304.871h18.105a3.43 3.43 0 0 0 2.305-.87 3.64 3.64 0 0 0 1.182-2.22l4.755-32.728a3.8 3.8 0 0 0-.1-1.545 3.7 3.7 0 0 0-.71-1.364m-7.432 35.09H24.281L19.526 24.97H47.14zM43.733 12.19V6.476c-.002-1.01-.368-1.977-1.018-2.69-.65-.714-1.53-1.116-2.448-1.12H26.4c-.919.004-1.799.406-2.448 1.12-.65.713-1.016 1.68-1.019 2.69v5.714H16V16h34.667v-3.81zm-3.466 0H26.4V6.476h13.867z" />
      <path d="M34.667 32H32v18.667h2.667z" />
    </g>
  </svg>
)
export default SvgDeleteIcon
